import React from "react";
import { Link } from 'react-router-dom';

import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';

// Material UI
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Tooltip } from "@mui/material";

// Components
import { DataGrid } from '@arredo/reactjs-ui';
import WrapperDatePicker from '../../../../components/wrapperDatapicker';
import Dropdown from '../../../../components/inputs/dropdown';
import Receipt from "@mui/icons-material/Receipt";

// Hooks
import useInvoiceSummary from '../../../../hooks/billing/useInvoiceSummary';

// Models
import { columns } from '../../../../models/InvoiceSummaryEntity';
import { VoucherTypes } from '../../../../models/VoucherTypes';

const SellerSales = () => {
    const { invoiceSummary, loading, filters, pvs, setFilters } = useInvoiceSummary();

    const handleFilterChange = (event) => {
        setFilters({ ...filters, [event.target.name]: event.target.value === 'all' ? null : event.target.value });
    }

    const ButtonLink = ({ type }) => {
        // TODO: Este filtro no es escalable por tipo de Comprobante
        const isInvoice = () =>
            type !== VoucherTypes.types.CreditNoteA &&
            type !== VoucherTypes.types.CreditNoteB &&
            type !== VoucherTypes.types.CreditNoteEFactura &&
            type !== VoucherTypes.types.CreditNoteETicket;
        const path = isInvoice()
            ? '/cashRegisters/invoices'
            : '/cashRegisters/vouchers';

        const title = isInvoice()
            ? 'Ver Facturas'
            : 'Ver Notas de Credito';

        return type !== 'Total' && (
            <Tooltip title={title}>
                <IconButton
                    component={Link}
                    to={`${path}?type=${type}&from=${filters.from}&to=${filters.to}${filters.billingCode ? `&billingCode=${filters.billingCode}` : ''}`}
                    size="large"
                >
                    {isInvoice() ? <Receipt /> : <ReceiptOutlinedIcon />}
                </IconButton>
            </Tooltip>
        );
    }

    return (
        <Grid container spacing={3}>
            <Grid
                size={{
                    xs: 12,
                    md: "grow"
                }}
            >
                <Typography variant='h4'>
                    Comprobantes
                </Typography>
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    md: 2
                }}
            >
                <Dropdown
                    fullWidth
                    name='billingCode'
                    onChange={handleFilterChange}
                    size='small'
                    label='PV'
                    getOptionLabel={(option) => option?.name}
                    getOptionValue={(option) => option?.billingCode}
                    value={filters?.billingCode || "all"}
                    values={pvs}
                />
            </Grid>
            <Grid
                size={{
                    xs: 6,
                    md: 3,
                    lg: 2
                }}
            >

                <WrapperDatePicker
                    filters={filters?.from}
                    handleFilterChange={handleFilterChange}
                    type="from"
                />
            </Grid>
            <Grid
                size={{
                    xs: 6,
                    md: 3,
                    lg: 2
                }}
            >

                <WrapperDatePicker
                    filters={filters?.to}
                    handleFilterChange={handleFilterChange}
                    type="to"
                />
            </Grid>
            <Grid size={12}>
                <DataGrid
                    columns={columns}
                    rows={invoiceSummary}
                    loading={loading}
                    actions={({ row }) => (
                        <>
                            <ButtonLink type={row.type} />
                        </>
                    )}
                />
            </Grid>
        </Grid>
    );
}

export default SellerSales;